const SELECTORS = {
	WRAPPER: '.js-filters',
	SUBMENU: '.js-filters__submenu',
	TOGGLE: '.js-filters__toggle',
	CLEAR: '.js-filters__clear',
	STATUS_TOGGLE_AREA: '.js-filters__toggle-selected',
	SUBMIT: '.js-filters__submit'
};

class Filter {
	constructor(wrapper) {
		this.wrapper = wrapper;
		this.form = document.querySelector('#content-hub-filters');
		this.allFilters = this.wrapper.querySelectorAll('input');
		this.filterSubmenu = this.wrapper.querySelector(SELECTORS.SUBMENU);
		this.filterToggle = this.wrapper.querySelector(SELECTORS.TOGGLE);
		this.filterClear = this.wrapper.querySelector(SELECTORS.CLEAR);
		this.statusToggleArea = this.wrapper.querySelector(SELECTORS.STATUS_TOGGLE_AREA);
		this.submitButton = this.wrapper.querySelector(SELECTORS.SUBMIT);

		this.isOpen = false;
		this.checkedCounter = this.wrapper.querySelectorAll('input:checked').length || 0;

		this.init();
	}

	init() {
		this.setStatusMessage();

		this.wrapper.addEventListener('click', (event) => {
			this.handleClick(event);
		});

		this.wrapper.addEventListener('keydown', (event) => {
			const { key } = event;

			if (key === 'Escape' && this.isOpen === true) {
				this.toggleFilters();
				this.filterToggle.focus();
			}
		});
	}

	handleClick(event) {
		const { classList, tagName } = event.target;

		if (classList.contains(SELECTORS.TOGGLE.substring(1))) {
			this.toggleFilters();
		} if (
			classList.contains(SELECTORS.CLEAR.substring(1))
		) {
			this.clearCheckboxes();
		} else if (tagName === 'INPUT') {
			this.handleCheck(event.target);
		}
	}

	handleCheck(input) {
		if (input.checked) {
			// eslint-disable-next-line no-plusplus
			this.checkedCounter++;
		} else {
			// eslint-disable-next-line no-plusplus
			this.checkedCounter--;
		}

		this.submitButton.removeAttribute('disabled');
		this.setStatusMessage(this.checkedCounter);
	}

	toggleFilters() {
		if (this.isOpen) {
			this.filterToggle.removeAttribute('aria-expanded');
			this.filterSubmenu.setAttribute('aria-hidden', 'true');
			this.isOpen = false;
		} else {
			this.filterToggle.setAttribute('aria-expanded', 'true');
			this.filterSubmenu.removeAttribute('aria-hidden');
			this.isOpen = true;
		}
	}

	setStatusMessage() {
		const message = `${this.checkedCounter} Selected`;

		if (this.checkedCounter === 0) {
			this.statusToggleArea.innerText = '';
		} else if (this.checkedCounter === 1) {
			const checkedInput = this.wrapper.querySelector('input:checked');
			this.statusToggleArea.innerText = `: ${checkedInput.getAttribute('data-text-value')}`;
		} else {
			this.statusToggleArea.innerText = `: ${message}`;
		}
	}

	clearCheckboxes() {
		this.allFilters.forEach((input) => {
			// eslint-disable-next-line no-param-reassign
			input.checked = false;
		});
		this.checkedCounter = 0;
		this.submitButton.removeAttribute('disabled');
		this.setStatusMessage();
	}
}


function initFilters() {
	const wrappers = document.querySelectorAll(SELECTORS.WRAPPER);
	[...wrappers].forEach((wrapper) => {
		// eslint-disable-next-line no-new
		new Filter(wrapper);
	});
}

export default initFilters;
